<button mat-icon-button (click)="onRemoveClick()">
  <mat-icon>remove</mat-icon>
</button>
